import { Link } from '@tanstack/react-router'
import { type FC } from 'react'

import { TableCell } from '@/components/table/table'

import { cn } from '@/lib/utils'

interface Props {
  id: number
  noPadding?: boolean
  children: React.ReactNode
  className?: string
}

export const ApplicantsTableCell: FC<Props> = ({ id, noPadding, children, className }) => {
  return (
    <TableCell className={cn('px-0', className)}>
      <Link className={cn('flex items-center', noPadding ? 'px-0' : 'px-4', 'py-2')} to={`/applicants/${id}`}>
        {children}
      </Link>
    </TableCell>
  )
}
